"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_utils_1 = require("./vue-utils");
var components = require("./components");
// Export the components as a Vue plugin.
exports.default = {
    install: function (Vue, options) {
        var includeComponents = options != null && Array.isArray(options.components) && options.components || undefined;
        vue_utils_1.registerComponents(Vue, components, includeComponents);
    }
};
